import {md5} from 'js-md5'
import Compressor from 'compressorjs'

export function getFileSignature(file: File | Blob) {
  return new Promise<string | null>((resolve) => {
    const reader = new FileReader()
    reader.onerror = () => resolve(null)
    reader.onabort = () => resolve(null)
    reader.onload = ({target}) => {
      if (!target?.result) {
        resolve(null)
        return
      }

      const signature = md5(target.result)
      resolve(signature)
    }

    reader.readAsArrayBuffer(file)
  })
}

export function getCompressedImage(
  file: File,
  options?: Omit<Compressor.Options, 'success' | 'error'>,
) {
  return new Promise<File | Blob | null>(
    (resolve) =>
      new Compressor(file, {
        ...options,
        success: resolve,
        error: () => resolve(null),
      }),
  )
}
